import request from '@/utils/request'
// 查询
export function getFeedBack(data) {
  return request({
    url: '/car/feedback/getFeedBack',
    method: 'get',
    params:data
  })
}
// 修改维修记录
export function delFeedBack(data) {
  return request({
    url: '/car/feedback/delete',
    method: 'post',
    params:data
  })
}